// Maker's signature — the [MK] mark + name, linking to melihkizmaz.dev (same as portfolio-new/brand/signature.html).
// Takes the surrounding text colour, so it works on light and dark footers.
export function MkSignature({ lang = 'tr' }: { lang?: 'tr' | 'en' | string }) {
  return (
    <a
      href="https://melihkizmaz.dev"
      target="_blank"
      rel="author noopener"
      title="Melih Kızmaz — Backend & DevOps Engineer"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: 'inherit', textDecoration: 'none', fontSize: 13, opacity: 0.8 }}
    >
      <svg viewBox="0 0 963 896" width={20} height={19} fill="currentColor" aria-hidden="true" style={{ flex: 'none' }}>
        <path d="M641 0 L541 0 L318 436 L153 146 L0 146 L0 748 L139 748 L139 679 L72 679 L72 215 L94 215 L285 558 L354 558Z M744 215 L645 215 L296 896 L395 896 L564 567 L677 748 L777 748 L610 477Z M824 146 L963 146 L963 748 L824 748 L824 679 L891 679 L891 215 L824 215Z" />
      </svg>
      <span>
        {lang === 'en' ? 'Designed & built by ' : 'Tasarım & geliştirme: '}
        <strong style={{ fontWeight: 600 }}>Melih Kızmaz</strong>
      </span>
    </a>
  );
}
